import { branchRoutes } from "./RouteExports/branchRoutes";
import { CRGroutes } from "./RouteExports/CRGroutes";
import { generalRoutes, dashboardRoute } from "./RouteExports/generalRoutes";

export default {
  routes: [dashboardRoute, ...CRGroutes, ...branchRoutes, ...generalRoutes],
  otherRoutes: [],
};
